import { createContext, FC, useContext } from 'react'
import { observer } from 'mobx-react'

import { AppContainer, GlobalStyle } from '@styles/App.styles'
import { Helmet } from './Helmet'
import { ContentRouter } from './ContentRouter'

import { rootStore } from '@store/Root.store'
import { ProviderNames } from '../store/AppState.store'
import { getPathname } from '@/methods/getWindowLocationData'

export const StoreContext = createContext(rootStore)

export const App: FC = observer(() => {
  const store = useContext(StoreContext)

  // theme
  if (!store.AppState.provider) {
    const provider = getPathname() || 'google'
    store.AppState.setProvider(provider ? (provider as ProviderNames) : 'google')
  }

  return (
    <StoreContext.Provider value={rootStore}>
      <Helmet title="Acount recovery app" description="Acount recovery" themeColor="#320822" />
      <GlobalStyle />
      <AppContainer className="app-container">
        <ContentRouter />
      </AppContainer>
    </StoreContext.Provider>
  )
})
